<template>
  <div id="app">
    <StepLocate v-if="this.$root.mode != 'card'" :step="this.$root.$store.state.step"></StepLocate>
    <template v-if="initialized === true">
      <div class="loading-overlay" id="loading-overlay"></div>
      <template v-if="error">
        <div style="width: 100%;margin: 0;padding: 0;height: calc(100vh - 140px)">
          <div class="d-flex justify-content-center align-items-center" style="height: 100%">
            <div class="m-4" style="font-size: 20px;"  v-html="error"></div>
          </div>
        </div>
      </template>
      <template v-else>
        <MyStep v-if="this.$root.mode != 'card'" :step="this.$root.$store.state.step"></MyStep>
        <ReserveInit
            v-if="this.$root.$store.state.step == 1 && this.$root.mode != 'view' && this.$root.mode != 'card'" @get-codes="getCodes" @get-service-setting="getServiceSetting"  />
        <UserDetail v-if="this.$root.$store.state.step == 2" @get-codes="getCodes" />
        <Cart v-if="this.$root.$store.state.step == 3" @get-codes="getCodes" />
        <Register v-if="this.$root.$store.state.step == 4" @get-codes="getCodes" ref="registerComponent" />
        <Thanks v-if="this.$root.$store.state.step == 5" @get-codes="getCodes" />
        <MyPage v-if="this.$root.mode == 'view'" @get-codes="getCodes" />
        <CardChange v-if="this.$root.mode == 'card'" />
      </template>
      <template v-if="this.$root.$route.query.langSelector === '1'">
        <LangSelector></LangSelector>
      </template>
    </template>
    <div v-else>
      <i class="fas fa-spinner fa-spin fa-2x"></i> 読み込み中・・・
    </div>
  </div>
</template>

<script>
import ReserveInit from './components/ReserveInit.vue'
import UserDetail from './components/UserDetail.vue'
import Cart from './components/Cart.vue'
import Register from './components/Register.vue'
import Thanks from './components/Thanks.vue'
import MyPage from './components/MyPage.vue'
import MyStep from './components/MyStep.vue'
import StepLocate from './components/StepLocate.vue'
import CardChange from './components/CardChange.vue'
import axios from 'axios'
import moment from 'moment'
import LangSelector from './components/LangSelector.vue'

export default {
  name: 'App',
  components: {
    LangSelector,
    ReserveInit,
    UserDetail,
    Cart,
    Register,
    Thanks,
    MyPage,
    MyStep,
    StepLocate,
    CardChange
  },
  data () {
    return {
      init: {
        service: false
      },
      reserveData: {},
      loading: false,
      error: ''
    }
  },
  computed: {
    initialized () {
      if (this.init.service === true) {
        return true
      }
      return false
    }
  },
  async created () {
    this.restoreLocale()
    // null の際はinit
    this.getServiceSetting()
    this.getCodes()
    this.$router.beforeRouteLeave = function (to, from, next) {
      console.log('beforeRouteLeave')
      console.log('beforeRouteLeave.to', to)
      console.log('beforeRouteLeave.from', from)
      alert('beforeRouteLeave')
      // next()
    }
    // console.log('/App:getServiceSetting')
    if (this.$root.mode === 'view' && this.$root.key !== '') {
      if (this.$root.$store.state.key !== this.$root.key) {
        this.$root.$store.commit('update', {
          name: 'key',
          value: this.$root.key
        })
        this.$root.$store.commit('update', {
          name: 'step',
          value: 3
        })
        this.getReserve()
      }
    } else if (this.$root.mode !== 'card') {
      if (this.$root.$route.query.c !== undefined && this.$root.$route.query.h !== undefined) {
        let custCode = this.$root.$route.query.c
        let hash = this.$root.$route.query.h
        let url = this.$root.baseURL + 'getOrder/' + custCode + '/' + hash
        // cache対策 日時を追加
        url += '?t=' + new Date().getTime()
        let _self = this

        await axios.get(url, {
          headers: {
            'Content-Type': 'application/json'
          },
          responseType: 'json'
        }).then(response => {
          // console.log('reserve:', response.data)
          if (response.data.error) {
            this.error = response.data.error
            _self.$root.$store.commit('update', { field: 'step', value: 999 })
          } else if (response.data.members) {
            let url = new URL(window.location.href)
            url.searchParams.set('ui', response.data.userId)

            if (response.data.introduce) {
              // url に int= を追加
              url.searchParams.set('int', response.data.introduce)
            }
            if (response.data.rentalType) {
              // url に type= を追加
              url.searchParams.set('type', response.data.rentalType)
            }
            if (response.data.dev) {
              // url に dev= を追加
              url.searchParams.set('dev', response.data.dev)
            }
            url.searchParams.set('from', 'order')

            // urlに反映
            window.history.pushState({}, '', url)
            // console.log('url', url.toString())

            Object.keys(response.data).forEach(key => {
              if (key !== 'step') {
                _self.$root.$store.commit('update', { field: key, value: response.data[key] })
              }
              _self.$root.$store.commit('update', { field: 'step', value: 1 })
            })
            // 登録ずみならthanks画面表示
            if (response.data.myPageHash) {
              _self.$root.$store.commit('update', { field: 'step', value: 5 })
            } else {
              _self.$root.$store.commit('update', { field: 'step', value: 4 })
            }
          }
        }).catch(error => {
          console.log('getOrder:Error', error)
        })
      } else {
        this.checkIntAndType()
      }
    }
  },
  mounted () {
    if (this.$root.$route.query.hash !== undefined && this.$root.$route.query.hash.length === 36) {
      this.getReserveDataForEdit()
    }
  },
  methods: {
    checkIntAndType () {
      const store = this.$root.$store
      const route = this.$root.$route

      // 初回未設定なら route からセット（commit を使い、直接代入しない）
      if (store.state.introduceCode === null && store.state.paymentType === null) {
        const introduceCode = route.query.int !== undefined ? route.query.int : null
        const paymentType = route.query.type !== undefined ? route.query.type : null
        // vue store 更新
        store.commit('update', { field: 'introduceCode', value: introduceCode })
        store.commit('update', { field: 'paymentType', value: paymentType })
      } else {
        const checkInt = route.query.int && route.query.int.trim() !== '' ? route.query.int : null
        const checkType = route.query.type && route.query.type.trim() !== '' ? route.query.type : null

        if (this.$root.mode !== 'view' && store.state.step < 5) {
          const intMismatch = store.state.introduceCode !== checkInt
          const typeMismatch = store.state.paymentType !== checkType

          if (intMismatch || typeMismatch) {
            // console.log('info: introduce/paymentType changed -> clearing persistence and reloading', {
            //   intMismatch,
            //   typeMismatch
            // })
            // 特定の値をクリア
            const clearValues = {
              'members': [],
              'step': 1,
              'paymentType': checkType,
              'introduceCode': checkInt,
              'willVisit': null,
              'reserve_term': null
            }
            // vue store 更新
            Object.keys(clearValues).forEach(field => {
              store.commit('update', { field: field, value: clearValues[field] })
            })

            // reload は一度だけ呼ぶ
            // console.log('info: reloading due to introduce/paymentType change')
            location.reload()
          }
        }
      }
    },

    async getServiceSetting () {
      let d = this.$root.$store.state.rentalDateY + '-' + this.$root.$store.state.rentalDateM + '-' + this.$root.$store.state.rentalDateD
      let int = (this.$root.$route.query.int) ? this.$root.$route.query.int : ''
      let from = (this.$root.$route.query.from) ? this.$root.$route.query.from : ''
      let url = this.$root.baseURL + 'getServiceSetting.json?int=' + int + '&from=' + from
      if (d.length > 0) {
        url += '&d=' + d
      }
      let _self = this
      let withCredentials = false
      await axios.get(url, {
        headers: {
          'Content-Type': 'application/json'
        },
        withCredentials: withCredentials,
        responseType: 'json'
      }).then((response) => {
        // console.log('getServiceSetting', response)
        _self.$root.serviceSetting = response.data
        // console.log(_self.$root.serviceSetting)

        let service = response.data.User
        let serviceName = service.name + ' ' + service.name_service
        if (response.data.introduce_name) {
          serviceName += ' (' + response.data.introduce_name + ')'
        }
        window.$('#SystemTitle').text(serviceName)
        window.$('title').text(serviceName)

        let enableTypeS = {
          field: 'enableTypeS',
          value: (response.data.enable_type_s.value === 'true')
        }
        let enableTypeV = {
          field: 'enableTypeV',
          value: (response.data.enable_type_v.value === 'true')
        }
        let enableName = {
          field: 'enableName',
          value: (response.data.enable_name.value === 'true')
        }
        let memberLimit = {
          field: 'memberLimit',
          value: response.data.max_members.value
        }
        let userId = {
          field: 'userId',
          value: response.data.ui
        }
        let reserveOpen = {
          field: 'reserveOpen',
          value: response.data.reserve_open
        }
        let reserveClose = {
          field: 'reserveClose',
          value: response.data.reserve_close
        }

        _self.$root.$store.commit('update', reserveOpen)
        _self.$root.$store.commit('update', reserveClose)
        _self.$root.$store.commit('update', enableTypeS)
        _self.$root.$store.commit('update', enableTypeV)
        _self.$root.$store.commit('update', enableName)
        _self.$root.$store.commit('update', memberLimit)
        _self.$root.$store.commit('update', userId)
        let asobito = {}
        if (response.data.asobito) {
          asobito = response.data.asobito
        }
        if (Object.keys(asobito).length > 0) {
          _self.$root.$store.commit('update', { field: 'isCRMMember', value: true })
          _self.$root.$store.commit('update', { field: 'isCRMRepeater', value: (asobito.isRepeater !== undefined ? asobito.isRepeater : false) })
          _self.$root.$store.commit('update', { field: 'tel', value: asobito.tel })
          _self.$root.$store.commit('update', { field: 'email', value: asobito.email })
          _self.$root.$store.commit('update', { field: 'email_retype', value: asobito.email })
          _self.$root.$store.commit('update', { field: 'address1', value: asobito.pref })
          _self.$root.$store.commit('update', { field: 'address2', value: asobito.address })
          _self.$root.$store.commit('update', { field: 'crm_id', value: asobito.memberId })
          _self.$root.$store.commit('update', { field: 'locked', value: asobito.locked })

          if (asobito.isRepeater === undefined || !asobito.isRepeater) {
            let members = []
            let sex = ''

            if (asobito.sex === 'male') sex = 'M'
            else if (asobito.sex === 'female') sex = 'F'

            let member = {
              first_name: '',
              last_name: asobito.name_kana,
              sex: sex,
              age: asobito.age,
              crm_code: 'asobito',
              crm_id: asobito.memberId,

              height: '160',
              weight: '',
              skier_type: '',
              shoe: '250',
              stance: '',
              request: '',
              item: '',
              rentalItems: {},
              itemInactive: {},
              itemCategory: '',
              itemCategoryName: '',
              itemCategoryPrice: 0,
              isRepresentative: false,
              req: {
                wear: '',
                ski: '',
                snb: '',
                ssk: '',
                // weight: '',
                text: ''
              }
            }
            members.push(member)
            _self.$root.$store.commit('update', { field: 'members', value: members })
          }
        }
        window.$('#header-wrapper').css({ 'cssText': 'background-color: ' + response.data.header_color_code.value })
        // console.log('root.store', _self.$root.$store)
        _self.init.service = true
      }).catch((error) => {
        console.log(error)
      }).finally(() => {
        console.log('/getServiceSetting')
      })
    },
    // keyからデータ取得
    getReserve () {
      let url = this.$root.baseURL + 'getReserve/' + this.$root.key + '.json'
      let _self = this
      axios
        .get(url, {
          headers: {
            'Content-Type': 'application/json'
          },
          responseType: 'json'
        })
        .then((response) => {
          _self.$root.viewData = response.data.reserve
          _self.$root.$store.commit('viewState', response.data.reserve)
        })
        .catch((error) => {
          console.log(error)
        })
    },
    // hashからデータ取得
    getReserveDataForEdit () {
      console.log('getReserveDataForEdit')
      var url = this.$root.baseURL + 'getReserveData/' + this.$root.$route.query.ui + '/' + this.$root.$route.query.hash
      var _self = this
      axios.get(url, {
        headers: { 'Content-Type': 'application/json' },
        responseType: 'json'
      }).then(response => {
        let obj = response.data.result
        _self.$root.reserveData = response.data.result
        console.log('obj', obj, 'state', _self.$root.$store.state)
        _self.$root.mode = 'view'
      })
    },
    // 表示言語を復元する #163
    // i18n.locale は初期値 'ja' で起動するが、store.lang は sessionStorage に
    // 永続化されている。SBPS/Square のカード登録から /reserve-app/success/ 等へ
    // 戻ると step2(UserDetail)を経由しないため、これまで locale が 'ja' のままだった。
    // URL の lang パラメータがあればそちらを優先する(言語指定URLの配布用)。
    restoreLocale () {
      let langParam = this.$root.$route.query.lang
      if (langParam && ['ja', 'en', 'cn'].indexOf(langParam) >= 0) {
        this.$root.$i18n.locale = langParam
        this.$root.$store.commit('update', { field: 'lang', value: langParam })
        return
      }
      if (this.$root.$store.state.lang) {
        this.$root.$i18n.locale = this.$root.$store.state.lang
      }
    },
    getCodes () {
      let d = moment(this.$root.$store.state.rentalDate)
      var url = this.$root.baseURL + 'getVariableCode.json?ui=' + this.$root.$route.query.ui + '&datetime_base=' + d.format('YYYY-MM-DD') + ' 00:00:00'
      axios.get(url, {
        headers: { 'Content-Type': 'application/json' },
        responseType: 'json'
      }).then(response => {
        let obj = response.data.result
        let objKeys = {
          TRM: 'term',
          IDC: 'idcard',
          AGE: 'age',
          SEX: 'sex',
          HEI: 'height',
          SHO: 'shoe',
          WGT: 'weight',
          SKR: 'skier_type'
        }
        let options = {}
        Object.keys(obj).forEach(function (key) {
          var newArray = []
          obj[key].forEach(array => {
            let eachOption = {}
            eachOption.name = array.Variable.name
            eachOption.value = array.Variable[objKeys[key]]
            newArray.push(eachOption)
          })
          options[key] = newArray
        })
        console.log('options', options)
        // 身分証明書は選択済みの値を保持する #190
        // getCodes() は step2 に戻るたびに呼ばれるため、無条件に先頭値を入れると
        // ユーザーの選択が「携帯電話番号」に戻ってしまう。
        // 未選択のとき、または選択肢から消えた値のときだけ先頭値を入れる。
        let currentIdcard = this.$root.$store.state.idcard
        let hasCurrentIdcard = options.IDC.some(option => option.value === currentIdcard)
        this.$root.$store.commit('update', { field: 'selectOptions', value: options })
        if (!hasCurrentIdcard) {
          this.$root.$store.commit('update', { field: 'idcard', value: options.IDC[0].value })
        }
      }).catch(error => {
        console.log(error)
      }).finally(() => {
        this.$root.$store.state.loading = false
      })
    }
  }
}
</script>
